export default __webpack_public_path__ + "static/AppBeers8-224ce616e197245f196f1ac22a3931d0.png";